import * as React from "react";
import styled from "styled-components";

import {
    LegendLabel,
    MarketResearchDiversityMetricData,
    Text,
} from "../../..";
import {
    DiversityGridBars,
    DiversityGridItem,
    DiversityGridLabel,
    DiversitySectionHeader,
    DiversitySectionHeaderLabel,
} from "./marketResearchDiversity";

interface DiversityDesktopSectionProps {
    summaryText: () => JSX.Element;
    title: string;
    graphTitle: string;
    metrics: MarketResearchDiversityMetricData[];
    gauge: React.ReactNode;
    isLocationRemote: boolean;
    bars: (metric: MarketResearchDiversityMetricData) => JSX.Element;
}
export const DiversityDesktopSection = (
    props: DiversityDesktopSectionProps
) => {
    const {
        summaryText,
        title,
        graphTitle,
        metrics,
        gauge,
        bars,
        isLocationRemote,
    } = props;

    const legend = () => {
        if (isLocationRemote) {
            return null;
        }

        return (
            <DiversityGridLegend>
                <LegendLabel color="#7E66D8" text="Regional" addMargin />
                <LegendLabel color="#E35AFC" text="State" />
            </DiversityGridLegend>
        );
    };
    return (
        <>
            {!isLocationRemote && (
                <DiversitySectionHeader>
                    <div>
                        <DiversitySectionHeaderLabel>
                            <Text variant="h3">{title}</Text>
                        </DiversitySectionHeaderLabel>
                        {summaryText()}
                    </div>
                    <div
                        style={{
                            width: "320px",
                        }}
                    >
                        {gauge}
                    </div>
                </DiversitySectionHeader>
            )}

            {!isLocationRemote && (
                <>
                    <DiversitySectionHeaderLabel>
                        <Text variant="h3">{graphTitle}</Text>
                    </DiversitySectionHeaderLabel>
                    <DiversityGridItem>
                        <DiversityGridLabel />
                        {legend()}
                    </DiversityGridItem>
                    {metrics.map((metric, index) => (
                        <DiversityGridItem key={index}>
                            <DiversityGridLabel>
                                <Text>
                                    <b>{metric.name}</b>
                                </Text>
                            </DiversityGridLabel>
                            <DiversityGridBars>
                                {bars(metric)}
                            </DiversityGridBars>
                        </DiversityGridItem>
                    ))}
                </>
            )}
        </>
    );
};

const DiversityGridLegend = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    margin-left: 32px;
    margin-bottom: 16px;
`;
